import { create } from 'zustand';

type State = {
  createMore: boolean;
  feedbackDesc: string;
  topicDesc: string;
};

type Actions = {
  setCreateMore: (status: boolean) => void;
  setFeedbackDesc: (value: string) => void;
  setTopicDesc: (value: string) => void;

  initEditorStore: () => void;
};

const initialState: State = {
  feedbackDesc: '',
  topicDesc: '',
  createMore: false,
};

const useEditorStoreTemp = create<State & Actions>((set, get) => ({
  ...initialState,
  setFeedbackDesc: (value) => {
    set({ feedbackDesc: value });
  },

  setTopicDesc: (value) => {
    set({ topicDesc: value });
  },

  setCreateMore(status) {
    set({
      createMore: status,
    });
  },
  initEditorStore() {
    set(initialState);
  },
}));

export default useEditorStoreTemp;
